import  React, { Component } from 'react'
import { Modal, Form, Input, Button, message  } from 'antd';

import './ModifyEmail.styl'
import { sendCodeToEmail, bingdingEmail } from '@/api/login'

export default class ModifyEmail extends Component{
  state = {
    captchaDisabled: false,
    captchaText: '发送验证码',
    confirmLoading: false
  }

  formRef = React.createRef();
  render() {
    const { captchaDisabled, captchaText, confirmLoading } = this.state;
    return (
      <div className="modify-email">
        <Modal
          title="请绑定企业邮箱"
          visible={this.props.visible}
          onOk={this.handleOk}
          confirmLoading={confirmLoading}
          onCancel={this.handleCancel}
        >
          <Form
            ref={this.formRef}
            name="emailForm"
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: '请输入企业邮箱!' }]}
            >
              <Input
                placeholder="请输入企业邮箱"
                addonAfter="@ruigushop.com"
              />
            </Form.Item>
            <Form.Item
              name="code"
              rules={[{ required: true, message: '请输入验证码!' }]}
            >
              <div className="flex-row-between-center">
                <Input placeholder="请输入验证码" className="input-200"/>
                <Button type="primary" onClick={this.handleGetCaptcha} disabled={captchaDisabled}>{captchaText}</Button>
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }

  /**
   * 绑定邮箱
   */
  handleOk = () => {
    this.formRef.current.validateFields()
    .then(values => {
      this.setState({confirmLoading: true});
      let params = {
        email: values.email + '@ruigushop.com',
        verificationCode: values.code
      }
      bingdingEmail(params).then(() => {
        this.setState({confirmLoading: false});
        this.formRef.current.resetFields();
        this.props.handleCloseModal(false);
        message.success('邮箱绑定成功');
      }).catch(err => {
        this.setState({confirmLoading: false});
        message.warning(err.message);
      })
    })
  }
  handleCancel = () => {
    message.warning('必须要绑定邮箱的哦~');
  }

  /**
   * 获取验证码
   */
  handleGetCaptcha = () => {
    const email =  this.formRef.current.getFieldValue('email');
    let reg = /^[a-z0-9]{1,}@ruigushop\.com$/;
    if(typeof email === 'undefined') {
      message.warning("请输入企业邮箱");
      return
    }
    if(!reg.test(email + '@ruigushop.com')) {
      message.warning("输入的邮箱格式有误");
      return
    }
    this.setState({captchaDisabled: true});
    let count = 60;
    sendCodeToEmail({email: email + '@ruigushop.com'}).then(() => {
      let time0 = setInterval(() => {
        if (count === 0) {
          clearInterval(time0);
          this.setState({
            captchaDisabled: false,
            captchaText: '重新发送验证码'
          });
          return
        }
        this.setState({captchaText: `${count}s 后可重新发送`});
        count--;
      }, 1000);
    }).catch(err => {
      this.setState({captchaDisabled: false});
      message.warning(err.message);
    })
  }
}
